import { Component, effect, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiAboutService } from '../Services/api-about.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from '../../environments/environment';
import { defaultSupportEmail } from "../app.component";
import { SessionService } from '../Services/session.service';
import { dashboardRoute } from '../route-names';
import { ElectorDataService } from '../Services/elector-data.service';
import { DecisionDialogService } from '../Services/decision-dialog.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: [],
    standalone: false
})
export class HeaderComponent implements OnInit{
  isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
  clientFAQ: string;
  supportEmail = defaultSupportEmail;
  routeName: string = "";
  title: string = "";
  dates: string = "";

  constructor(private readonly router: Router,
    public readonly about: ApiAboutService,
    private breakpointObserver: BreakpointObserver,
    readonly sessionService: SessionService,
    public electorDataService: ElectorDataService,
    public decisionDialogService: DecisionDialogService,
  ) {
    this.clientFAQ = environment.clientWebURL
    this.routeName = this.router.url
    const registrationSettings = about.aboutInformation.value.org_feature_set.registrationSettings
    const votingSettings = about.aboutInformation.value.org_feature_set.miscSettings
    if (registrationSettings && this.routeName.startsWith('/registration')) {
      this.about.headerTitle.set(votingSettings?.header ?? "");
      this.about.headerDates.set(registrationSettings.headerText ?? "");
    } 
    effect(() => {
      this.title = this.about.headerTitle();
      this.dates = this.about.headerDates();
    });
  }

  ngOnInit() {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
  }

  onActivate(): void {
    window.scrollTo(0, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
  }

  gotoDashboard() {
    this.router.navigate(dashboardRoute);
  }

}
